export default function getUserInitials(firstName, lastName) {
  return firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
}